import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { getStorageKey, matchTimeZoneCode } from '../utils';

export interface IAxiosRequestConfig extends AxiosRequestConfig {
  /** 允许截流 */
  allowIntercept?: boolean;
  /** 语言 */
  withLanguage?: boolean;
  /** 时区 */
  withTimezone?: boolean;
  /** 币种 */
  withCurrency?: boolean;
}

export default class Interceptors {
  instance: AxiosInstance;

  constructor(defaultConfig: IAxiosRequestConfig = {}) {
    this.instance = axios.create({
      ...defaultConfig,
      timeout: 30 * 1000, // 30 seconds
    });
    this.interceptorsRequest();
    this.interceptorsResponse();
  }

  getInstance = () => {
    return this.instance;
  };

  /** 请求拦截 */
  interceptorsRequest = () => {
    this.instance.interceptors.request.use(
      (config: IAxiosRequestConfig) => {
        const newConfig = config;

        const { withLanguage, withCurrency, withTimezone } = config;

        if (config.method === 'get') {
          if ((withLanguage || withCurrency || withTimezone) && !newConfig.data) {
            newConfig.params = {};
          }
          if (withLanguage) {
            newConfig.params.languageCode = localStorage.getItem(getStorageKey('language')) || '';
          }
          if (withCurrency) {
            newConfig.params.currency = localStorage.getItem(getStorageKey('currency')) || '';
          }
          if (withTimezone) {
            newConfig.params.timezone = matchTimeZoneCode();
          }
        } else {
          if ((withLanguage || withCurrency || withTimezone) && !newConfig.data) {
            newConfig.data = {};
          }
          if (withLanguage && !config.data.languageCode) {
            newConfig.data.languageCode = localStorage.getItem(getStorageKey('language')) || '';
          }
          if (withCurrency && !config.data.currency) {
            newConfig.data.currency = localStorage.getItem(getStorageKey('currency')) || '';
          }
          if (withTimezone && !config.data.timezone) {
            newConfig.data.timezone = matchTimeZoneCode();
          }
        }
        return { ...newConfig };
      },
      (error) => {
        return Promise.reject(error);
      },
    );
  };

  /** 响应拦截 */
  interceptorsResponse = () => {
    this.instance.interceptors.response.use(
      (response) => {
        if (response.data.message) {
          const { code } = response.data.message;
          if (!code) {
            return Promise.resolve(response);
          }
          return response.data.message;
        } else {
          const { code } = response.data;
          if (!code) {
            return Promise.resolve(response);
          }
          return response.data;
        }
      },
      (error) => {
        return Promise.reject(error);
      },
    );
  };
}
